import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaPaperPlane,
} from "react-icons/fa";
import "./contactus.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

const info = [
  {
    icon: <FaMapMarkerAlt />,
    title: "Office Address",
    desc: "Gift City, Gandhinagar, Gujarat 382355",
  },
  {
    icon: <FaPhoneAlt />,
    title: "Phone Number",
    desc: "+91 98765 43210",
  },
  {
    icon: <FaEnvelope />,
    title: "Email Address",
    desc: "info@gccgujarat.com",
  },
  {
    icon: <FaClock />,
    title: "Working Hours",
    desc: "Mon - Fri : 10:00 AM - 6:00 PM",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 70 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.7,
    },
  }),
};

const Contactus = () => {
  return (
    <div>
      {/* Header */}
      <Header />

      <section className="contactHero">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h1>Contact Us</h1>

            <p>
              We'd love to hear from you. Let's discuss your business goals and
              help you establish your presence in GIFT City.
            </p>
          </motion.div>
        </Container>
      </section>

      {/* Contact */}

      <section className="contactSection">
        <Container>
          <Row className="g-5">
            {/* Left */}

            <Col lg={5}>
              {info.map((item, index) => (
                <motion.div
                  key={index}
                  custom={index}
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <Card className="contactCard mb-4">
                    <Card.Body>
                      <div className="iconBox">{item.icon}</div>

                      <div>
                        <h5>{item.title}</h5>

                        <p>{item.desc}</p>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              ))}
            </Col>

            {/* Right */}

            <Col lg={7}>
              <motion.div
                initial={{ opacity: 0, x: 80 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <Card className="formCard">
                  <Card.Body>
                    <h2>Send us a Message</h2>

                    <Form>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label>Name</Form.Label>

                            <Form.Control
                              type="text"
                              placeholder="Enter your name"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label>Email</Form.Label>

                            <Form.Control
                              type="email"
                              placeholder="Enter your email"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label>Phone</Form.Label>

                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label>Company</Form.Label>

                            <Form.Control
                              type="text"
                              placeholder="Company Name"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="mb-4">
                        <Form.Label>Subject</Form.Label>

                        <Form.Control placeholder="Subject" />
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Label>Message</Form.Label>

                        <Form.Control
                          as="textarea"
                          rows={6}
                          placeholder="Write your message..."
                        />
                      </Form.Group>

                      <Button className="sendBtn">
                        Send Message
                        <FaPaperPlane className="ms-2" />
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Map */}

      <section className="mapSection">
        <iframe
          title="map"
          src="https://maps.google.com/maps?q=gift%20city&t=&z=13&ie=UTF8&iwloc=&output=embed"
          loading="lazy"
        ></iframe>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contactus;
